import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useWarehouseTransferList(params) {
  return useSWR(
    !!params?.fromWarehouse || !!params?.toWarehouse || !!params?.provider
      ? {
          path: `/api/v1/warehouse-transfers`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWarehouseTransferList;
